import { useTranslation } from '@rhino-project/core/i18n';
import { LinkButton } from '../../components/buttons';
import { useForgotPasswordPath } from '@rhino-project/core/hooks';
import { AuthPage, type AuthPageProps } from './AuthPage';
import {
  Alert,
  AlertContent,
  AlertTitle,
  AlertDescription
} from '@heroui/react';

export const ResetPasswordExpiredPage = (props: AuthPageProps) => {
  const { t } = useTranslation();
  const forgotPasswordPath = useForgotPasswordPath();

  return (
    <AuthPage title={t('rhino.frontend.messages.link_expired')} {...props}>
      <Alert status="danger" className="bg-danger/10 border border-danger/20">
        <AlertContent>
          <AlertTitle>
            {t('rhino.frontend.messages.password_reset_token_has_expired')}
          </AlertTitle>
          <AlertDescription>
            {t(
              'rhino.frontend.messages.you_tried_to_reset_your_password_but_the_secure_link_has_expired'
            )}
          </AlertDescription>
        </AlertContent>
      </Alert>
      <div className="mt-4">
        <LinkButton to={`../${forgotPasswordPath}`}>
          {t('rhino.frontend.messages.try_again')}
        </LinkButton>
      </div>
    </AuthPage>
  );
};
